import { startPortalTrace } from '../hooks/usePortalTrace';

/**
 * Bring every markup lockup under `root` to life — the ones built by
 * primaryLockupHtml, for the pages that are exported HTML rather than React (the
 * landing, and New Here inside its iframe). The portal already spins by CSS
 * (.pr-portal-spin, in index.css or PORTAL_SPIN_CSS inside the iframe); this
 * starts the trace (hooks/usePortalTrace) — one scheduler for every lockup on the
 * page, so three logos cost one timer.
 *
 * prefers-reduced-motion: the portal holds still and the trace copy comes out of
 * the DOM, exactly as PortalLogo leaves them.
 *
 * Returns a cleanup function.
 */
export default function animateLockups(target) {
  // New Here hands over the iframe's Document; the trace needs an element to animate.
  const root = target?.nodeType === 9 ? target.documentElement : target;
  if (!root?.querySelectorAll) return () => {};
  const win = root.ownerDocument?.defaultView || window;
  const reduced = !!win.matchMedia?.('(prefers-reduced-motion: reduce)')?.matches;

  if (reduced) {
    root.querySelectorAll('[data-trace]').forEach((n) => n.remove());
    root.querySelectorAll('img[data-portal-o]').forEach((n) => n.classList.remove('pr-portal-spin'));
    return () => {};
  }

  return startPortalTrace(root);
}
